import {
  clsx
 ,Box 
 ,Link 
} from 'external/material'
import LinkBehavior from './Link'
import icons from 'resources/icons'

export default function Assignment({id, count, type, iconProps}) {
  const Icon = icons[type]
  return (<Link underline="none" component={LinkBehavior} groupId={id} target={type} className={clsx('assignment', type)}>
    <Box className={clsx('icon', type)}>
      <Icon {...(iconProps || {})}/>
    </Box>
    <Box className={clsx('count', type)}>
      {count}
    </Box>
  </Link>)
}
